export const CLIENT_ROUTE = '/song-group';
export const API_ROUTE = '/api/song-group';
export const CLIENT_TITLE = 'Дууны бүлэг';